import { useRef } from "react";
import { CameraIcon } from "../../../../../svg";
import { useDispatch } from "react-redux";
import { addFiles } from "../../../../../features/chatSlice";
import { getFileType } from "../../../../../utils/file";

export default function CameraAttachment() {
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const handleCapture = (e) => {
    let files = Array.from(e.target.files);
    files.forEach((file) => {
      if (!file.type.startsWith("image/")) {
        files = files.filter((item) => item.name !== file.name);
        return;
      }
      if (file.size > 1024 * 1024 * 10) {
        files = files.filter((item) => item.name !== file.name);
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (ev) => {
        dispatch(
          addFiles({
            file,
            fileData: ev.target.result,
            type: getFileType(file.type),
          })
        );
      };
    });
  };

  return (
    <li>
      <button
        type="button"
        className="bg-[#D3396D] rounded-full"
        onClick={() => inputRef.current.click()}
        title="التقاط صورة"
        aria-label="التقاط صورة"
      >
        <CameraIcon />
      </button>
      <input
        type="file"
        hidden
        ref={inputRef}
        accept="image/*"
        capture="environment"
        onChange={handleCapture}
      />
    </li>
  );
}
